import React, { useEffect, useState } from 'react'
import { Switch, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import Home from './components/home/Home'
import useScroll from './hooks/useScroll'
import AboutUs from './components/AboutUs'
import Pricing from './components/home/paymentSection/pricing'
import PrivacyPolicy from './components/PrivacyPolicy'
// Initialize Google Analytics

const App = () => {
  const [navigationBarVisible, setNavigationBarVisible] = useState(true)

  const { direction } = useScroll()

  useEffect(() => {
    setNavigationBarVisible(direction === 'up')
  }, [direction])

  return (
    <>
      <Navigation visible={navigationBarVisible} />
      <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/about-us' component={AboutUs} />
        <Route exact path='/pricing' component={Pricing}/>
        <Route exact path='/privacy-policy' component={PrivacyPolicy} />
      </Switch>
    </>
  )
}

export default App
